/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAppShortlink} from '../api'

 export const useQueryGetAppShortlink = createReactQueryHook('getAppShortlink', getAppShortlink)
